import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowRight, CalendarDays } from "lucide-react";
import { Reveal } from "./Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const FixturesStrip = () => {
  const [upcoming, setUpcoming] = useState(null);

  useEffect(() => {
    axios.get(`${API}/fixtures`).then((r) => setUpcoming(r.data.upcoming.slice(0, 3))).catch(() => setUpcoming([]));
  }, []);

  if (!upcoming || upcoming.length === 0) return null;

  return (
    <section className="max-w-7xl mx-auto px-5 sm:px-8 mt-20 sm:mt-28" data-testid="home-fixtures">
      <Reveal>
        <div className="flex items-end justify-between gap-6 mb-8">
          <div>
            <p className="text-xs font-mono-club uppercase tracking-[0.25em] text-[#E5AC3C] mb-3">Next up at West Park and beyond</p>
            <h2 className="font-head text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight">Upcoming fixtures</h2>
          </div>
          <Link to="/fixtures" className="hidden sm:inline-flex items-center gap-2 text-sm font-bold text-[#9BB0C1] hover:text-[#E5AC3C] transition-colors" data-testid="fixtures-view-all-link">
            All fixtures <ArrowRight size={15} />
          </Link>
        </div>
      </Reveal>
      <div className="grid gap-4 md:grid-cols-3">
        {upcoming.map((f, i) => (
          <Reveal key={f.id} delay={i * 0.08}>
            <Link to="/fixtures" data-testid={`home-fixture-card-${i}`}>
              <div className="h-full rounded-2xl border border-white/10 bg-[#122030] p-6 hover:border-[#E5AC3C]/40 transition-colors">
                <span className="text-[10px] font-mono-club uppercase tracking-[0.15em] text-[#E5AC3C] border border-[#E5AC3C]/30 rounded-full px-2.5 py-1">{f.team}</span>
                <h3 className="mt-3 font-head text-lg font-bold">vs {f.opponent}</h3>
                <p className="mt-2 text-xs text-[#9BB0C1] inline-flex items-center gap-1.5">
                  <CalendarDays size={12} />
                  {new Date(`${f.date}T12:00:00`).toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short" })}
                  {f.time ? ` · ${f.time}` : ""} · {f.venue === "Away" ? "Away" : "Home"}
                </p>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
